export type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'voided' | 'written_off';
export type PaymentMethod = 'cash' | 'card' | 'eft' | 'medical_aid' | 'other';

export interface LineItem {
  code: string;
  description: string;
  codeType: 'icd10' | 'nhrpl' | 'consumable';
  quantity: number;
  unitPrice: number;
  total: number;
}

export interface Payment {
  id: string;
  amount: number;
  method: PaymentMethod;
  reference: string;
  notes: string;
  createdAt: string;
  createdBy: string;
}

export interface Invoice {
  id: string;
  invoiceNumber: string;
  patientId: string;
  patientName: string;
  appointmentId?: string;
  lineItems: LineItem[];
  subtotal: number;
  totalPaid: number;
  balance: number;
  status: InvoiceStatus;
  notes: string;
  sentAt?: string;
  voidReason?: string;
  voidedAt?: string;
  voidedBy?: string;
  clinicalNoteId?: string;
  emailHistory?: Array<{ sentAt: string; sentTo: string; sentBy: string; subject: string; gmailMessageId?: string }>;
  writeOffAmount?: number;
  writeOffReason?: string;
  writtenOffAt?: string;
  writtenOffBy?: string;
  balanceStatementSentAt?: string;
  payments?: Payment[];
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface DailySummary {
  date: string;
  totalBilled: number;
  totalCollected: number;
  outstanding: number;
  invoiceCount: number;
  paymentCount: number;
}

export const STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft: 'Draft',
  sent: 'Sent',
  paid: 'Paid',
  voided: 'Voided',
  written_off: 'Written Off',
};

export const STATUS_COLORS: Record<InvoiceStatus, string> = {
  draft: 'bg-gray-100 text-gray-700',
  sent: 'bg-blue-100 text-blue-700',
  paid: 'bg-green-100 text-green-700',
  voided: 'bg-red-100 text-red-600 line-through',
  written_off: 'bg-amber-100 text-amber-700',
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Cash',
  card: 'Card',
  eft: 'EFT',
  medical_aid: 'Medical Aid',
  other: 'Other',
};
